<template>
	<div class="filter-map">
		<div class="filter-group">
			<map-filter v-for="(key, index) in filters"
						:key="key.id"
						:list="key"
						:list-placeholder="allData.filter_placeholders[index]"
						@filter-change="filterChange($event, index)"
			></map-filter>
		</div>
		<div class="leaflet-map-wrapper">
			<div ref="map" class="leaflet-map"></div>
		</div>
	</div>
</template>

<script>
	// import {LMap, LTileLayer, LPopup, LMarker} from 'vue2-leaflet';
	// import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
	require('leaflet');
	require('leaflet.markercluster');
	import MapFilter  from './leafletMap/leaflet.vue';
	export default {
		name: 'leafletMap',
		data() {
			return {
				map: null,
				tileLayer: null,

				center: L.latLng(50.121, 29.993),
				focus: 7,
				// marker: L.latLng(47.413220, -1.219482),
				activeFilters: {},
				markers: [],
				outputMarkers: [],
				filterMarkers: [],
				params: {},
				filters: [],
				allData: {},
				mapHeight: window.innerHeight / 100 * 70
			}
		},
		components: { MapFilter },
		created() {
			fetch(`${YAMASTERS_FRONTEND.ajaxPath}?get=map`,{method: "GET"}).then(response => response.json())
				.then(data => {
					this.params = data.params;
					this.markers = data.items;
					this.outputMarkers = data.items;
					this.filters = data.filter;
					this.allData = data;
				})
				.then(() => {
					this.filterMarkets();
					if(this.allData.params) {
						if(this.allData.params.view) {
							this.center = L.latLng(this.allData.params.view.split(',')[0],
								this.allData.params.view.split(',')[1])
						}
						if(this.allData.params.focus){
							this.focus = this.allData.params.focus;
						}
					}
					// console.log(this.allData.params.view)
					// this.createMap();
					// this.createListFilter();

					this.createMap();
				})
		},
		mounted() {
			$('.leaflet-map').css({'height': this.mapHeight + 'px'});
			window.preloader.start(false, $('.leaflet-map-wrapper')[0]);
		},
		methods: {
			initMap() {
				this.map = L.map(this.$refs.map).setView(this.center, this.focus);

				this.tileLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
					maxZoom: 19,
					attribution: '© <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
				});
				this.tileLayer.addTo(this.map);

			},
			destroyMap() {
				this.map.off();
				this.map.remove();
			},
			createMap() {
				this.initMap();
				setTimeout(() => {
					// this.$nextTick(this.initLocation);
					this.initLocation();
				}, 100);
			},
			initLocation() {
				let markers = L.markerClusterGroup();

				function r(min, max) {
					return Math.random() * (max - min) + min;
				}
				let icon = L.divIcon({
					className: 'icon'
				});
				// Quick test with 5k markers:

				for(let key of this.filterMarkers) {
					let marker = L.marker([ key.x, key.y
					], {
						// icon: this.createIcon()
						icon: this.createIcon()
					});
					// console.log(this.createPopup(key));
					if(key.print) {
						marker.bindPopup(this.createPopup(key));
					}

					markers.addLayer(marker); // <= but only to MCG
				}
				this.map.addLayer(markers);
				this.$nextTick(window.preloader.stop);
			},
			filterChange(data, filterName) {
				window.preloader.start(false, $('.leaflet-map-wrapper')[0]);
				this.destroyMap();
				if(data.clear) {
					delete this.activeFilters[filterName];
					this.filterMarkets();
					this.createMap();
					return;
				}
				this.activeFilters[filterName] = data;
				// console.log(data);
				this.filterMarkets();
				if(data.x && data.y) {
					this.center = L.latLng(data.x, data.y)
				};
				if(data.focus){
					this.focus = data.focus;
				};
				this.createMap();
			},
			filterMarkets() {
				// console.log(Object.keys(this.activeFilters).length);
				if(Object.keys(this.activeFilters).length === 0) {
					this.filterMarkers = this.markers;
					return;
				};

				this.filterMarkers = this.outputMarkers.filter((element) => {
					for(let key in this.activeFilters) {
						// console.log(element[key]);
						if(element[key] !== this.activeFilters[key].value) return false;
						// console.log(this.activeFilters[key].value);
					}
					return true;
				});
				// console.log(this.filterMarkers);
			},
			createIcon() {
				var icon;
				if(this.params.icon) {
					icon = L.icon({
						iconUrl: this.params.icon.url,
						iconSize:     [25, 41],
						iconAnchor:   [14, 41],
						popupAnchor:  [-1, -46]
					})
				} else {
					icon = L.icon({
						iconUrl: './img/marker-icon.png',
						iconSize:     [25, 41], // size of the icon
						iconAnchor:   [14, 41], // point of the icon which will correspond to marker's location
						popupAnchor:  [-1, -46] // point from which the popup should open relative to the iconAnchor
					})
				}

				return icon;
			},
			createPopup(element) {
				// console.log(element);
				var popup = document.createElement('div');
				if(element.name !== undefined) {
					var title = document.createElement('div');
					title.innerHTML = element.name;
					title.classList.add('map-popup-title');
					popup.appendChild(title);
				}
				element.print.forEach((text) => {
					//запускаем цикл по внутрянке
					for(var key in text) {
						switch (key) {
							case 'name' :
								let name = document.createElement('div');
								name.classList.add('map-popup-name');
								name.innerHTML = text[key];
								popup.appendChild(name);
								break;
							case 'value' :
								let value = document.createElement('div');
								value.classList.add('map-popup-value');
								value.innerHTML = text[key];
								popup.appendChild(value);
								break;
							case 'link' :
								let link = document.createElement('a');
								link.classList.add('map-popup-link');
								link.classList.add('g-link');
								link.innerHTML = text[key]['value'];
								link.href = text[key]['href'];
								popup.appendChild(link);
								break;
							default:
								let another = document.createElement('div');
								another.classList.add('map-popup-another');
								another.innerHTML = text[key];
								popup.appendChild(another);
						}
						// console.log(key);
					}

				});
				// console.dir(popup.outerHTML);
				return popup.outerHTML;
				// return popup;
			},
			createListFilter() {
				// console.log(this.filters);
				// console.log(this.allData.clear_filter);
				if(this.allData.clear_filter){
					for(let key in this.allData.clear_filter) {
						// console.log(key);
						this.filters[key].unshift(this.allData.clear_filter[key]);
					}
				}
			}
		},
	}
</script>
<style lang="scss">
	@import "~leaflet/dist/leaflet.css";
	@import "~leaflet.markercluster/dist/MarkerCluster.css";
	@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
	@import "scss/wanted";
	.leaflet-container{
		height: 500px;
	}
	.filter-group{
		display: flex;
		flex-wrap: wrap;
		.filter-list{
			margin-bottom: 25px;
			max-width: 100%;
			@include m_up{
				max-width: calc(50% - 12px);
				&:nth-of-type(2n+1){
					margin-right: 24px;
				}
			}
			@include l_up{
				max-width: calc(25% - 18.75px);
				&{
					margin-right: 25px;
				}
				&:nth-of-type(4n){
					margin-right: 0px;
				}
			}
		}
		/*.filter-list{*/
		/*	margin-right: 25px;*/
		/*}*/
	}
	.filter-map {
		.map-popup-title{
			font-weight: 700;
			font-size: 1rem;
			margin-bottom: 10px;
			color: var(--bg-color);
		}
		.map-popup-name{
			font-weight: 600;
			font-size: 0.9375rem;
			color: #333333;
			margin-top: 10px;
			margin-bottom: 2px;
		}
		.map-popup-value{
			font-weight: 400;
			font-size: 0.875rem;
			color: #333333;
			margin-bottom: 4px;
		}
		.map-popup-another, .map-popup-link{
			color: #7e8183;
		}
		.map-popup-link:hover{
			cursor: pointer;
		}
	}
</style>


// WEBPACK FOOTER //
// leafletMap.vue?2f0f9ab0